import { render, staticRenderFns } from "./ThirdPartySoftware.vue?vue&type=template&id=406c8d71&"
import script from "./ThirdPartySoftware.vue?vue&type=script&lang=js&"
export * from "./ThirdPartySoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports